export default __webpack_public_path__ + "static/media/step3.77cdd63d.png";